import { render, staticRenderFns } from "./g24rce_settings.vue?vue&type=template&id=a7587806&"
import script from "./g24rce_settings.vue?vue&type=script&lang=js&"
export * from "./g24rce_settings.vue?vue&type=script&lang=js&"
import style0 from "./g24rce_settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7587806')) {
      api.createRecord('a7587806', component.options)
    } else {
      api.reload('a7587806', component.options)
    }
    module.hot.accept("./g24rce_settings.vue?vue&type=template&id=a7587806&", function () {
      api.rerender('a7587806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/integrations/g24rce_settings.vue"
export default component.exports